import axios from 'App/axios';
import { DASHBOARD_BILLING_PLANS_URL } from '../urls';

export async function updateToFreePlan(): Promise<void> {
  await axios.post(DASHBOARD_BILLING_PLANS_URL);
}
